import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import 'url-search-params-polyfill';
import {
  TabContainer,
  TabContext,
  Tab,
  SimpleDataTable,
  Section,
  toLineItem,
  slugify
} from '@budget-monorepo/shared-ui';

import './index.scss';

class SubTab extends Component {
  onTabChange = (tabRef, curLocation) => {
    const { parentTab, location } = this.props;
    if (global.window && curLocation.href && tabRef.current) {
      const subTab = tabRef.current.innerText;
      const { pathname } = location;
      const url = `${pathname}?tab=${slugify(parentTab.name)}&subtab=${slugify(subTab)}`;
      // eslint-disable-next-line no-undef
      window.history.replaceState({}, '', url);
    }
  };

  onTabLinkClicked = (index, subContext) => {
    const { tabIds, setActiveTab } = subContext;
    if (tabIds instanceof Map) {
      const tabId = tabIds.get(index);
      setActiveTab(tabId);
    }
  };

  urlToTabIndex = (location) => {
    if (!location.href) {
      return null;
    }
    const { tabObj } = this.props;
    const url = new URL(location.href);
    const params = new URLSearchParams(url.search);
    const param = params.get('subtab');
    let index = 0;
    tabObj.subTabs.every((tab, tabIndex) => {
      if (slugify(tab.name) === param) {
        index = tabIndex;
        return false;
      }
      return true;
    });
    return index;
  };

  render() {
    const {
      parentTab, location, tabObj, path, title
    } = this.props;
    return(
      <TabContainer nested defaultTab={this.urlToTabIndex(location)} onTabChange={(tabRef) => this.onTabChange(tabRef, location)}>
        {tabObj.subTabs.map((subTab, i) => {
          const subTabValue = subTab.value;
          const subTabData = tabObj[subTabValue] && tabObj[subTabValue].data;
          const subTabTotal = tabObj[subTabValue] && tabObj[subTabValue].total;
          const tabKey = `appropriation-subTab.${i}`;
          const subTabTableData = [];
          for (let j = 0; j < subTabData.length; j += 1) {
            const d = subTabData[j];
            if (d) {
              const {
                organization, govLevelOne, govLevelTwo, govLevelThree, lineItemNumber, lineItemName, ...rest
              } = d;
              let data = null;
              const govLevel = govLevelOne || (govLevelTwo || govLevelThree);
              if (organization) {
                if (subTabValue === 'summary') {
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  data = {
                    organization: (
                      <TabContext.Consumer>
                        {(context) => (
                          <button type="button" className="ma_button--link" onClick={() => this.onTabLinkClicked(j + 1, context)}>{organization}</button>
                        )}
                      </TabContext.Consumer>
                    ),
                    ...rest
                  };
                } else if (govLevel) {
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  data = { organization: (<Link to={`${path}/${slugify(govLevel)}?tab=${slugify(parentTab.name)}&subtab=${slugify(subTab.name)}`}>{organization}</Link>), ...rest };
                } else {
                  data = { organization, ...rest };
                }
              }
              if (lineItemNumber) {
                if (subTabValue === 'summary') {
                  data = {
                    lineItemNumber: (
                      <TabContext.Consumer>
                        {(context) => (
                          <button type="button" className="ma_button--link" onClick={() => this.onTabLinkClicked(j + 1, context)}>{lineItemNumber}</button>
                        )}
                      </TabContext.Consumer>
                    ),
                    ...rest
                  };
                } else {
                  data = {
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    lineItemNumber: (<Link to={`${path}/${lineItemNumber}`}>{toLineItem(lineItemNumber)}</Link>),
                    lineItemName,
                    ...rest
                  };
                }
              }
              if (data) {
                subTabTableData.push(data);
              }
            }
          }

          // change the first column header name to category on summary subTab
          let summarySubTabHeaders = tabObj.headers.map((header) => {
            switch (header.value) {
              case 'organization':
                return{ ...header, name: 'Category' };
              case 'lineItemNumber':
                return{ ...header, name: 'Category' };
              default:
                return header;
            }
          });
          // remove lineItemName in summary subTab for govLevelThree appropriations
          summarySubTabHeaders = summarySubTabHeaders.filter((header) => header.value !== 'lineItemName');
          const subTabHeaders = (subTabValue === 'summary') ? summarySubTabHeaders : tabObj.headers;

          const subTabTable = subTabTableData && {
            data: subTabTableData,
            total: subTabTotal,
            headers: subTabHeaders
          };
          return(
            <Tab key={tabKey} title={subTab.name}>
              <Section>
                <SimpleDataTable title={`${title} ${parentTab.name} ${subTab.name}`} table={subTabTable} maxColWidth={400} download={`${location.pathname}-${parentTab.name}-${subTab.name}`} />
              </Section>
            </Tab>
          );
        })
      }
      </TabContainer>
    );
  }
}

SubTab.propTypes = {
  title: PropTypes.string,
  location: PropTypes.object,
  parentTab: PropTypes.object,
  tabObj: PropTypes.object,
  historicalSpending: PropTypes.object,
  path: PropTypes.string
};
SubTab.contextType = TabContext;


export default SubTab;
